import romanApi from "@roman/shared/lib/net/romanApi";
import type { PredictionMarketRanking } from "@roman/shared/types/PredictionMarket";
import type { SWRConfiguration } from "swr";
import useSWR from "swr";

export type PredictionMarketRankingProps = {
  predictionMarketId: string;
  swrOptions?: SWRConfiguration;
  fetcher?: (url: string, predictionMarketId: string) => Promise<PredictionMarketRanking>;
  /**
   * Optional cache bust key to force refetch.
   * When this value changes, SWR will refetch the data.
   */
  cacheBustKey?: number;
};

export const createDefaultPredictionMarketRankingFetcher = () => {
  return (url: string, predictionMarketId: string) => {
    return romanApi.get<PredictionMarketRanking>(`${url}/${predictionMarketId}`);
  };
};

export const useGetPredictionMarketRanking = ({
  predictionMarketId,
  swrOptions,
  fetcher,
  cacheBustKey,
}: PredictionMarketRankingProps) => {
  const rankingFetcher = fetcher || createDefaultPredictionMarketRankingFetcher();
  const swrKey = ["/prediction-market/rankings", predictionMarketId, cacheBustKey];

  const swrQuery = useSWR<PredictionMarketRanking>(swrKey, ([url, id]) => rankingFetcher(url, id), swrOptions);

  return swrQuery;
};
